<div class="tags-page">
  <p-tabView class="underline-tabs">
    <p-tabPanel header="{{ 'tags.dialog.active' | transloco }}">
      <aero-button [aeroTooltip]="activeTags.length >= 20 ? ('tags.dialog.maxTagsLimit' | transloco) : null"
                   [disabled]="activeTags.length >= 20" class="button-right" labelCode="create_collection_submit_label"
                   [size]="buttonSlimSize"
                   (click)="toggleAddForm()">
      </aero-button>

      <!-- Current Tags -->
      <h2 *ngIf="activeTags.length === 0"
          class="dashboard-accordion-header">{{ 'tags.dialog.noTagsCreated' | transloco }}</h2>

      <table *ngIf="activeTags.length > 0" class="no-labels bulb-dashboard-lower-table">
        <thead>
        <tr class="bulb-dashboard-lower-table-first-row">
          <th class="col-name" transloco="tags.dialog.tagName">Name</th>
          <th class="col-grades">{{ 'organization_dashboard_bottom_grade_tab' | translate }}</th>
          <th class="col-uses" transloco="tags.dialog.usedIn">Used In</th>
          <!--        <th class="col-used">Used/Expected</th>-->
          <th class="col-actions" transloco="tags.dialog.actions">Actions</th>
        </tr>
        </thead>

        <tbody>
        <tr *ngFor="let tag of activeTags; let i = index">
          <td class="tag-main">
            <div class="tag-name-row">
              <span class="color-dot" [ngStyle]="{'background': tag.colorCode}"></span>
              <span class="tag-name">{{ tag.name }}</span>
            </div>

            <div class="tag-description">
              {{ tag.description || '' }}
            </div>
          </td>
          <td>
            {{ formatGrades(tag.grades) }}
          </td>
          <td>{{ tag.noOfUses === -1 ? 0 : tag.noOfUses }}</td>
          <!--        <td>{{ tag.used }} / {{ tag.expectedUses || '-' }}</td>-->

          <!-- Actions -->
          <td class="actions">
          <span class="icon icon-edit"
                aeroTooltip="{{ 'button_edit' | translate }}" (click)="editTag(tag, i)">
            <i class="fas fa-edit"></i>
          </span>

            <span class="icon icon-delete"
                  aeroTooltip="{{ 'button_delete' | translate }}" *ngIf="!tag.editing"
                  (click)="showConfirmDialog(tag)">
                <i class="fa fa-trash-alt"></i>
          </span>
          </td>
        </tr>
        </tbody>
      </table>

    </p-tabPanel>

    <p-tabPanel header="{{ 'tags.dialog.deleted' | transloco }}">
      <h2 *ngIf="inactiveTags.length === 0"
          class="dashboard-accordion-header">{{ 'tags.dialog.noDeleted' | transloco }}</h2>

      <div *ngIf="inactiveTags.length > 0" class="card">
        <!-- Inactive Tags -->
        <table *ngIf="inactiveTags.length > 0" class="bulb-dashboard-lower-table">
          <thead>
          <tr class="bulb-dashboard-lower-table-first-row">
            <th class="col-name" transloco="tags.dialog.tagName">Name</th>
            <th class="col-grades">{{ 'organization_dashboard_bottom_grade_tab' | translate }}</th>
            <th class="col-uses" transloco="tags.dialog.usedIn">Used In</th>
            <!--        <th class="col-used">Used/Expected</th>-->
          </tr>
          </thead>
          <tbody>
          <tr *ngFor="let tag of inactiveTags">
            <td class="tag-main">
              <div class="tag-name-row">
                <span class="color-dot" [ngStyle]="{'background': tag.colorCode}"></span>
                <span class="tag-name">{{ tag.name }}</span>
              </div>

              <div class="tag-description">
                {{ tag.description || '' }}
              </div>
            </td>
            <td>{{ formatGrades(tag.grades) }}</td>
            <td>{{ tag.noOfUses === -1 ? 0 : tag.noOfUses }}</td>
            <!--        <td>{{ tag.used }} / {{ tag.expectedUses || '-' }}</td>-->
          </tr>
          </tbody>
        </table>

      </div>
    </p-tabPanel>
  </p-tabView>
</div>
